import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../../services/api';

export default function AbaCurso({ produtoId }) {
  const [curso, setCurso]           = useState(null);
  const [duracaoMin, setDuracaoMin] = useState('');
  const [descricao, setDescricao]   = useState('');
  const [enviando, setEnviando]     = useState(false);
  const [erro, setErro]             = useState('');
  const [ok, setOk]                 = useState('');
  const inputRef = useRef(null);

  const carregar = useCallback(async () => {
    if (!produtoId) { setCurso(null); return; }
    try {
      const { data } = await api.get(`/produtos/${produtoId}/curso`);
      setCurso(data);
      setDuracaoMin(data?.duracao_min ?? '');
      setDescricao(data?.descricao_curso ?? '');
    } catch { setCurso(null); }
  }, [produtoId]);

  useEffect(() => { carregar(); }, [carregar]);

  const enviar = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setEnviando(true); setErro(''); setOk('');
    try {
      const fd = new FormData();
      fd.append('video', file);
      if (duracaoMin) fd.append('duracao_min', duracaoMin);
      if (descricao) fd.append('descricao_curso', descricao);
      await api.post(`/produtos/${produtoId}/curso`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setOk('Vídeo enviado com sucesso!');
      await carregar();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao enviar o vídeo.');
    } finally {
      setEnviando(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const salvarDados = async () => {
    if (!curso) return;
    setErro(''); setOk('');
    try {
      const fd = new FormData();
      // reenvia sem trocar o arquivo — precisa de multipart mesmo assim
      // (o multer só olha req.body quando o form é multipart), então manda
      // um arquivo vazio referenciando o já existente não é preciso: só
      // atualiza os campos direto, sem novo upload.
      await api.put(`/produtos/${produtoId}/curso/dados`, { duracao_min: duracaoMin || null, descricao_curso: descricao || null });
      setOk('Dados atualizados!');
      await carregar();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar.');
    }
  };

  const excluir = async () => {
    if (!window.confirm('Remover o vídeo deste curso? O produto deixa de ser vendável como curso.')) return;
    try {
      await api.delete(`/produtos/${produtoId}/curso`);
      setCurso(null); setDuracaoMin(''); setDescricao('');
    } catch (err) { setErro(err.response?.data?.erro || 'Erro ao excluir.'); }
  };

  if (!produtoId) {
    return (
      <div style={{ padding: 24, color: '#888', fontSize: 13, fontStyle: 'italic' }}>
        Salve o produto antes de cadastrar o vídeo do curso.
      </div>
    );
  }

  return (
    <div style={{ padding: 12 }}>
      <p style={{ fontSize: 12, color: '#666', marginBottom: 12 }}>
        Anexe o vídeo do curso — ele fica guardado num local protegido do servidor
        (não em <code>/uploads</code>, que é público) e só é liberado por um link
        temporário depois que o comprador paga e loga com a conta que criou na compra.
      </p>

      <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12, fontWeight: 600 }}>
          Duração (minutos)
          <input type="number" min="0" value={duracaoMin} onChange={e => setDuracaoMin(e.target.value)}
            style={{ padding: '6px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4, width: 140 }} />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12, fontWeight: 600, flex: 1, minWidth: 240 }}>
          Descrição do curso (aparece na vitrine)
          <input value={descricao} onChange={e => setDescricao(e.target.value)}
            style={{ padding: '6px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4 }} />
        </label>
      </div>

      {curso && (
        <button style={{ padding: '6px 14px', fontSize: 13, cursor: 'pointer', marginBottom: 12 }} onClick={salvarDados}>
          Salvar duração/descrição
        </button>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <button
          style={{ padding: '6px 14px', fontSize: 13, cursor: 'pointer' }}
          disabled={enviando}
          onClick={() => inputRef.current?.click()}>
          {enviando ? 'Enviando…' : curso ? '🎬 Trocar vídeo' : '🎬 Enviar vídeo do curso'}
        </button>
        <input ref={inputRef} type="file" accept="video/*" style={{ display: 'none' }} onChange={enviar} />
        <span style={{ fontSize: 11, color: '#777' }}>MP4, até 2 GB.</span>
      </div>

      {erro && (
        <div style={{ background: '#fef2f2', border: '1px solid #ef4444', borderRadius: 4,
          padding: '6px 10px', fontSize: 12, color: '#b91c1c', marginBottom: 10 }}>
          {erro}
        </div>
      )}
      {ok && (
        <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 4,
          padding: '6px 10px', fontSize: 12, color: '#15803d', marginBottom: 10 }}>
          {ok}
        </div>
      )}

      {curso ? (
        <div style={{ fontSize: 13, color: '#444' }}>
          ✅ Vídeo cadastrado{curso.duracao_min ? ` — ${curso.duracao_min} min` : ''}.
          <button style={{ marginLeft: 12, border: 'none', background: 'none', cursor: 'pointer', fontSize: 12, color: '#b91c1c' }}
            onClick={excluir}>✕ Remover vídeo</button>
        </div>
      ) : (
        <div style={{ color: '#888', fontSize: 13, fontStyle: 'italic' }}>
          Nenhum vídeo cadastrado ainda — este produto não aparece como curso na vitrine.
        </div>
      )}
    </div>
  );
}
